import { Modal } from '@odin-labs/components';
import React from 'react';
import type { PublishChecks } from 'siteLayout';

export type PublishDraftModalProps = {
  isOpen: boolean;
  siteName: string;
  nextRevisionNumber: number;
  currentRevisionNumber: number | null;
  checks: PublishChecks;
  publishing: boolean;
  onCancel: () => void;
  onPublish: () => void;
  onOpenItem: (type: 'zone' | 'entry', id: string) => void;
};

const classes = {
  body: 'odin-flex odin-flex-col odin-gap-4',
  lead: 'odin-text-sm odin-text-gray-900',
  blocker:
    'odin-flex odin-flex-col odin-gap-1 odin-rounded-md odin-bg-red-50 odin-px-3 odin-py-2 odin-text-sm odin-text-gray-900',
  link: 'odin-self-start odin-text-xs odin-font-medium odin-text-odin-primary hover:odin-underline',
};

/**
 * The second confirm before a layout goes live: says plainly that access
 * changes the moment it is published, and lists anything that blocks it.
 * Unplaced readers are the Devices tab's concern, not a reason to hesitate.
 */
export function PublishDraftModal({
  isOpen,
  nextRevisionNumber,
  checks,
  publishing,
  onCancel,
  onPublish,
  onOpenItem,
}: PublishDraftModalProps): React.ReactElement {
  return (
    <Modal
      open={isOpen}
      setOpen={(open) => !open && onCancel()}
      title={`Publish version ${nextRevisionNumber}`}
      size="md"
      actionText="Publish"
      actionButtonEnabled={checks.canPublish && !publishing}
      actionButtonWithSpinner={publishing}
      onAction={onPublish}
      cancelText="Cancel"
      onCancel={onCancel}
    >
      <div className={classes.body}>
        <p className={classes.lead}>
          Once published, site access will be controlled by this layout version.
        </p>
        {checks.blocking.map((blocker) => (
          <div key={blocker.text} className={classes.blocker}>
            <span>{blocker.text}</span>
            {blocker.items.map((item) => (
              <button
                key={item.id}
                type="button"
                className={classes.link}
                onClick={() => onOpenItem(item.type, item.id)}
              >
                {item.label}
              </button>
            ))}
          </div>
        ))}
      </div>
    </Modal>
  );
}
